import axios from "../axios";

export default class ContingencyServices {
  async registerUser(request) {
    let res = await axios.post("Contingency/RegisterUser", request);
    return res.data;
  }

  async authenticate(userData) {
    let res = await axios.post("/Contingency/Login", userData);
    return res.data;
  }

  async registerUserByAdm(userData) {
    let res = await axios.post("/Contingency/RegisterAdmProfileUser", userData);
    return res.data;
  }

  async getHistoricalContingency() {
    let res = await axios.get("/Contingency/HistoricalContingency");
    return res.data;
  }

  async getJustifyActiveContingency() {
    let res = await axios.get("/Contingency/JustifyActiveContingency");
    return res.data;
  }

  async eneableContingency(data) {
    let res = await axios.post("/Contingency/activateContingency", data);
    return res.data;
  }

  async disableContingency(data) {
    let res = await axios.post("/Contingency/DeactivateContingency", data);
    return res.data;
  }

  async userGenetateToken(userData) {
    let res = await axios.post("/user/login", userData);
    return res.data;
  }

  async resetPassword(userData) {
    let res = await axios.patch("/Contingency/ResetPassword", userData);
    return res.data;
  }
}
